import { createRouter, createWebHashHistory } from 'vue-router';
import MainLayout from '@/layouts/MainLayout.vue';
import Login from "@/views/LoginComponent.vue";
import SetPassword from "@/views/SetPasswordComponent.vue";
import ForgotPassword from "@/views/ForgotPasswordComponent.vue";
import MFA from "@/views/MFAComponent.vue";
import Dashboard from "@/views/DashboardComponent.vue";
import Roles from "@/views/RolesComponent.vue";
import NewRole from "@/views/NewRoleComponent.vue";
import EditRole from "@/views/EditRoleComponent.vue";
import Users from "@/views/UsersComponent.vue";
import NewUser from "@/views/NewUserComponent.vue";
import EditUser from "@/views/EditUserComponent.vue";
import { checkAuth, getAuthorities, triggerMFA } from '@/utils/auth';
import eventBus from '@/utils/eventBus';

const routes = [
    {
        path: '/',
        component: Login,
        name: 'login',
        meta: {
            title: 'Login'
        }
    },
    {
        path: '/set-password',
        component: SetPassword,
        name: 'setPassword',
        meta: {
            title: 'Set Password'
        }
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
        name: 'forgotPassword',
        meta: {
            title: 'Forgot Password'
        }
    },
    {
        path: '/verification',
        component: MFA,
        name: 'verification',
        meta: {
            title: 'Verification'
        }
    },
    {
        path: '/dashboard',
        component: MainLayout,
        children: [
            {
                path: '',
                component: Dashboard,
                name: 'dashboard',
                meta: {
                    title: 'Dashboard',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/roles',
        component: MainLayout,
        children: [
            {
                path: '',
                component: Roles,
                name: 'roles',
                meta: {
                    title: 'Roles',
                    requiresAuth: true,
                    requiredAuthority: 'USER_MANAGE',
                }
            }
        ]
    },
    
    {
        path: '/roles/new',
        component: MainLayout,
        children: [
            {
                path: '',
                component: NewRole,
                name: 'newRole',
                meta: {
                    title: 'New Role',
                    requiresAuth: true,
                    requiredAuthority: 'USER_MANAGE'
                }
            }
        ]
    },
    {
        path: '/roles/:roleId',
        component: MainLayout,
        children: [
            {
                path: '',
                component: EditRole,
                name: 'editRole',
                meta: {
                    title: 'Edit Role',
                    requiresAuth: true,
                    requiredAuthority: 'USER_MANAGE'
                }
            }
        ]
    },
    {
        path: '/users',
        component: MainLayout,
        children: [
            {
                path: '',
                component: Users,
                name: 'users',
                meta: {
                    title: 'Users',
                    requiresAuth: true,
                    requiredAuthority: 'USER_MANAGE'
                }
            }
        ]
    },
    {
        path: '/users/new',
        component: MainLayout,
        children: [
            {
                path: '',
                component: NewUser,
                name: 'newUser',
                meta: {
                    title: 'New User',
                    requiresAuth: true,
                    requiredAuthority: 'USER_MANAGE'
                }
            }
        ]
    },
    {
        path: '/users/:userId',
        component: MainLayout,
        children: [
            {
                path: '',
                component: EditUser,
                name: 'editUser',
                meta: {
                    title: 'Edit User',
                    requiresAuth: true,
                    requiredAuthority: 'USER_MANAGE'
                }
            }
        ]
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
        checkAuth().then((result) => {
            if (result) {
                getAuthorities().then((authorities) => {
                    if (to.meta.requiredAuthority && !authorities.includes(to.meta.requiredAuthority)) {
                        eventBus.emit('show-alert', { message: 'You do not have permission to access this page.', type: 'danger' });
                        next({ name: 'dashboard' });
                    } else {
                        if (localStorage.getItem('mfaVerified')) {
                            next();
                        } else if (to.meta.requiresMFA) {
                            triggerMFA().then((result) => {
                                if (result) {
                                    next();
                                } else {
                                    next({ name: 'verification' });
                                }
                            });
                        }
                    }
                });
            } else {
                eventBus.emit('show-alert', { message: 'You need to log in to access this page.', type: 'danger' });
                next({ name: 'login' });
            }
        });
    } else {
        next();
    }
});

router.afterEach((to) => {
    document.title = to.meta.title.concat(' | TradeLite');
});

export default router;